// ─── 1. src/routes/modules/employeeRoutes.jsx — update with view/edit ─────────

import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import MasterLayout   from '../../masterLayout/MasterLayout';

import ViewEmployees from '../../pages/Employee/ViewEmployees';
import AddEmployee   from '../../pages/Employee/AddEmployees';
import ViewEmployee  from '../../pages/Employee/ViewEmployee';
import EditEmployee  from '../../pages/Employee/EditEmployee';

const employeeRoutes = (
  <>
    <Route path="/employee/view"
      element={<ProtectedRoute><MasterLayout><ViewEmployees /></MasterLayout></ProtectedRoute>} />
    <Route path="/employee/view/:id"
      element={<ProtectedRoute><MasterLayout><ViewEmployee /></MasterLayout></ProtectedRoute>} />
    <Route path="/employee/add"
      element={<ProtectedRoute><MasterLayout><AddEmployee /></MasterLayout></ProtectedRoute>} />
    <Route path="/employee/edit/:id"
      element={<ProtectedRoute><MasterLayout><EditEmployee /></MasterLayout></ProtectedRoute>} />
  </>
);

export default employeeRoutes;

